import { ArrowRight, Clock, Zap } from "lucide-react";
import whatsappIcon from "/src/assets/icons/whatsapp.svg";

export function FinalCTA() {
    return (
        <section id="final-cta" className="relative py-24 bg-slate-950 overflow-hidden">
            {/* Background grid e glow */}
            <div className="absolute inset-0 bg-grid opacity-30" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-500/20 rounded-full blur-[150px]" />

            <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                {/* Badge com ícone */}
                <div className="inline-flex items-center gap-2 bg-brand-500/10 border border-brand-400/50 rounded-full px-4 py-2 mb-8 shadow-[0_0_20px_rgba(34,197,94,0.3)]">
                    <Zap className="w-4 h-4 text-brand-400" />
                    <span className="text-brand-300 text-sm font-medium">Vagas limitadas</span>
                </div>

                <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6">
                    Pronto para{" "}
                    <span className="text-brand-400 drop-shadow-[0_0_15px_rgba(74,222,128,0.5)]">
                        transformar
                    </span>{" "}
                    sua clínica?
                </h2>

                <p className="text-xl text-slate-300 mb-10 max-w-2xl mx-auto">
                    Vagas limitadas para garantir atenção exclusiva a cada cliente.
                    Não deixe sua concorrência ocupar o espaço que é seu.
                </p>

                {/* Botão CTA principal com efeito de luz - Link direto para WhatsApp */}
                <div className="mb-8">
                    <a
                        href="https://api.whatsapp.com/send/?phone=5583999004689&text=Olá%2C+gostaria+de+informações+sobre+o+tráfego+pago+e+inteligência+artificial&type=phone_number&app_absent=0"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-3 bg-brand-400 hover:bg-brand-500 text-slate-950 text-xl font-bold px-10 py-5 rounded-full transition-all duration-300 transform hover:scale-105 btn-glow animate-pulse-glow shadow-[0_0_40px_rgba(185,255,102,0.5)]"
                    >
                        <img src={whatsappIcon} alt="" className="w-6 h-6" />
                        Quero minha vaga agora
                        <ArrowRight className="w-6 h-6" />
                    </a>
                </div>

                {/* Info adicional */}
                <div className="flex items-center justify-center gap-2 text-slate-400">
                    <Clock className="w-4 h-4" />
                    <span>Resposta em até 24 horas</span>
                </div>
            </div>
        </section>
    );
}
